import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, CheckCircle2 } from 'lucide-react';
import BottomNav from '../components/BottomNav';
import DesktopHeader from '../components/DesktopHeader';

const CleanerAttendance = () => {
  const [month, setMonth] = useState(new Date());
  const year = month.getFullYear();
  const m = month.getMonth();
  const first = new Date(year, m, 1).getDay();
  const days = new Date(year, m + 1, 0).getDate();

  const status = {};
  for (let i = 1; i <= days; i++) {
    if (i === new Date().getDate() && m === new Date().getMonth()) status[i] = 'present';
    else if (i % 7 === 0) status[i] = 'off';
    else if (i % 5 === 0) status[i] = 'absent';
    else if (i < new Date().getDate() || m < new Date().getMonth()) status[i] = 'present';
  }

  const cells = [];
  for (let i = 0; i < first; i++) cells.push(null);
  for (let i = 1; i <= days; i++) cells.push(i);

  const present = Object.values(status).filter((v) => v === 'present').length;
  const absent = Object.values(status).filter((v) => v === 'absent').length;

  return (
    <div className="min-h-screen bg-neutral-50 pb-24 md:pb-8">
      <DesktopHeader />

      <div className="max-w-[1200px] mx-auto px-5 md:px-6 pt-4 md:pt-8">
        <h1 className="text-xl md:text-2xl font-extrabold">Attendance</h1>
        <p className="text-sm text-neutral-500 mt-0.5">Your monthly attendance record</p>

        <div className="mt-4 grid md:grid-cols-3 gap-3">
          <StatBox color="#2E7D32" bg="#E8F5E9" label="Present" value={present} />
          <StatBox color="#EA580C" bg="#FFF3E0" label="Absent" value={absent} />
          <StatBox color="#1E88E5" bg="#E3F2FD" label="Total days" value={days} />
        </div>

        <div className="mt-4 bg-white border border-neutral-200 rounded-2xl p-4 md:p-6 max-w-2xl">
          <div className="flex items-center justify-between mb-3">
            <button onClick={() => setMonth(new Date(year, m - 1, 1))} className="w-8 h-8 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors"><ChevronLeft className="w-4 h-4" /></button>
            <p className="font-bold">{month.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
            <button onClick={() => setMonth(new Date(year, m + 1, 1))} className="w-8 h-8 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors"><ChevronRight className="w-4 h-4" /></button>
          </div>

          <div className="grid grid-cols-7 gap-1 text-center text-[10px] font-bold text-neutral-500 uppercase mb-2">
            {['S','M','T','W','T','F','S'].map((d, i) => <div key={i}>{d}</div>)}
          </div>
          <div className="grid grid-cols-7 gap-1">
            {cells.map((day, idx) => {
              if (!day) return <div key={idx} />;
              const st = status[day];
              const bg = st === 'present' ? 'bg-[#E8F5E9] text-[#2E7D32]' : st === 'absent' ? 'bg-[#FFEBEE] text-red-600' : st === 'off' ? 'bg-neutral-100 text-neutral-500' : 'bg-white text-neutral-700';
              return (
                <div key={idx} className={`aspect-square rounded-lg ${bg} flex items-center justify-center text-sm font-semibold`}>{day}</div>
              );
            })}
          </div>

          <div className="mt-4 flex items-center justify-center gap-4 text-xs">
            <Legend color="bg-[#E8F5E9]" text="Present" />
            <Legend color="bg-[#FFEBEE]" text="Absent" />
            <Legend color="bg-neutral-100" text="Off" />
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

const StatBox = ({ color, bg, label, value }) => (
  <div className="bg-white border border-neutral-200 rounded-xl p-4 flex items-center gap-3">
    <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: bg }}>
      <CheckCircle2 className="w-5 h-5" style={{ color }} />
    </div>
    <div>
      <p className="text-xs text-neutral-500">{label}</p>
      <p className="font-bold text-lg" style={{ color }}>{value}</p>
    </div>
  </div>
);

const Legend = ({ color, text }) => (
  <div className="flex items-center gap-1">
    <span className={`w-3 h-3 rounded ${color}`} />
    <span className="text-neutral-600">{text}</span>
  </div>
);

export default CleanerAttendance;
